import _ from 'lodash';
import api from '@/api';
import base64toPDF from '../../lib/base64ToPDF';
import Cookies from '@/portal-cookie';
import { message } from 'antd';


const initialState = {
    cardCode: '',
    cardType: '',
    cardName: '',
    loading: false,
    loaded: false,
    loadedVendorCode: false,
    showStatementPDFDialog: false,
    showContactDialog: false,
    pdfModalLoading: false,
    pdfModalData: null,
    pdfFilePreview: null,
    pdfModalKey: null,
};

export const types = {
    SET_STATE: 'STATEMENTS/SET_STATE',

};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_STATE:
            return { ...state, ...action.data };
        default:
            return state;
    }
};

export default reducers;

export const actions = {
    setState: (data) => ({ type: types.SET_STATE, data }),

    resetContactDialog: () => ({
        type: types.SET_STATE, data: {
            showContactDialog: false,
        },
    }),

    resetStatementPDFDialog: () => ({
        type: types.SET_STATE, data: {
            showStatementPDFDialog: false,
        },
    }),

    reset: () => ({ type: types.SET_STATE, data: { ...initialState } }),


    loadVendorCode: () => async (dispatch) => {
        console.log('[Statements.redux] loadVendorCode')
        try {
            const userKey = Cookies.get('TS_UserKey', '');
            const response = await api.get('/statements/vendor-code', {
                params: {
                    userKey: userKey,
                },
            });
            dispatch({
                type: types.SET_STATE,
                data: {
                    loading: false,
                    loadedVendorCode: true,
                    cardCode: response.BPCode,
                    cardType: response.BPType,
                },
            });
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.SET_STATE,
                data: {
                    loading: false,
                    loadedVendorCode: true,
                    cardCode: '',
                    cardType: '',
                },
            });
        }
    },

    loadStatementPreview: (docEntry) => async (dispatch) => {
        console.log('[Statements.redux] loadStatementPreview  docEntry: ' + docEntry);
        dispatch(actions.setState({ pdfModalLoading: true }));
        try {
            const response = await api.get('/statements/preview', {
                params: {
                    docEntry,
                    // TODO what params
                }
            });

            let fileData = response.FileData;
            let pdf = base64toPDF(fileData);

            dispatch(actions.setState({ pdfModalKey: docEntry }));
            dispatch(actions.setState({ pdfModalDocNum: docNum }));
            dispatch(actions.setState({ pdfModalData: fileData }));
            dispatch(actions.setState({ pdfFilePreview: pdf }));
            dispatch(actions.setState({ pdfModalLoading: false }));
        } catch (e) {
            console.error(e);
            message.error('Could not load statement preview');
            dispatch(actions.setState({ pdfModalLoading: false }));
        }
    },

 
  
  
   
};
